import "./styles.css";
import { useState } from "react";

export default function Header(props) {
  let [input, setInput] = useState("");
  let { darkMode, setDarkMode, setData } = props;

  //declaración y manejo de la lógica de busqueda. (10--->29)

  const search = () => {
    fetch(
      "https://api.giphy.com/v1/gifs/search" +
        "?q=" +
        input +
        "&api_key=D6TZBIoCG1TNnpy8EAt5q7hvovUd1NHF"
    )
      .then((response) => response.json())
      .then((data) => setData(data))
      .catch((error) => console.log(error));
  };

  let handleSearch = () => {
    input = input.replace(/ /g, "+");
    search();
  };

  let handleInput = (e) => {
    setInput(e.target.value);
  };

  //manejo del estado del modo oscuro. (33--->35)

  let handleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  //logica para ejecutar la busqueda utilizando "Enter". (39--->43)

  let handleEnter = (e) => {
    if (e.keyCode === 13) {
      return document.getElementById("btn").click();
    }
  };

  return (
    <>
      <div className="header">
        {darkMode ? (
          <img src="./img/logo-mobile-modo-noct.svg" alt=""></img>
        ) : (
          <img src="./img/logo-desktop.svg" alt=""></img>
        )}
        <button
          onClick={handleDarkMode}
          className={darkMode ? "dark-button-dark" : "dark-button"}
        >
          {darkMode ? "LIGHT MODE" : "DARK MODE"}
        </button>
      </div>
      <div className="searchbar-container">
        <p className={darkMode ? "title-dark" : "title"}>
          ¡Inspirate y busca los mejores <span className="heavy">GIFS</span>!
        </p>
        <img width="400px" src="./img/ilustra_header.svg" alt=""></img>
        <div className={darkMode ? "search-black" : "search"}>
          <input
            onKeyUp={handleEnter}
            onChange={handleInput}
            className={darkMode ? "searchbar-black" : "searchbar"}
            type="text"
            placeholder="Busca gifs"
          ></input>
          <button
            id="btn"
            onClick={handleSearch}
            className={darkMode ? "search-button" : "search-button-black"}
          >
            <img width="90%" src="./img/icon-search-mod-noc.svg" alt=""></img>
          </button>
        </div>
      </div>
      <div>
        <h4 className={darkMode ? "results-dark" : "results"}>
          Resultados de la búsqueda
        </h4>
      </div>
    </>
  );
}
